import { render, staticRenderFns } from "./CapituloOchoPage.vue?vue&type=template&id=55f263c5"
import script from "./CapituloOchoPage.js?vue&type=script&lang=js&external"
export * from "./CapituloOchoPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports